
import modelBase from '../../models/model-base.model';
import { apiStatusCodes } from '../../config/global-variables';

var projectModel = {

    getProjectQuota: function (successCallback, failureCallback) {
        modelBase.get(successCallback, failureCallback, '/api/ConfigurationMaster/AzureCustomVisionProjectQuota', {});
    },

    getProjectsList: function (successCallBack, failureCallBack, isImageNeeded = true) {
        if (isImageNeeded) {
            modelBase.get(successCallBack, failureCallBack, '/api/objectdetection/projects', {});
        } else {
            modelBase.get(successCallBack, failureCallBack, '/api/objectdetection/projects/list', {});
        }
        
    },

    getProjectInfo: function (successCallBack, failureCallBack, projectId) {
        modelBase.get(successCallBack, failureCallBack, '/api/objectdetection/projects/' + projectId, {});
    },

    createNewProject: function (successCallBack, failureCallBack, projectName, projectDescription) {
        var params = {};
        params.name = projectName.trim();
        params.description = projectDescription;

        if (params.name.length == 0) {

            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "Please enter a name for the project." });
            
            failureCallBack(error);

            return;
        }

        var path = '/api/objectdetection/projects';
        modelBase.post(successCallBack, failureCallBack, path, { body:params });
    },

    editProject: function (successCallBack, failureCallBack, projectId, projectName, projectDescription) {
        var params = {};
        params.name = projectName.trim();
        params.description = projectDescription;

        if (params.name.length == 0) {

            let error = new Error();
            error.code = apiStatusCodes.badRequest;
            error.response = [];
            error.response.push({ code: "LT00000010XX", message: "Please enter a name for the project." });
            
            failureCallBack(error);

            return;
        }

        var path = '/api/objectdetection/projects/' + projectId;
        modelBase.post(successCallBack, failureCallBack, path, { body:params });
    },

    deactivateProject: function (successCallBack, failureCallBack, projectId) {
        var params = {};

        var path = '/api/objectdetection/projects/' + projectId + '/deactivate';
        modelBase.post(successCallBack, failureCallBack, path, { body:params });
    },
}




export default projectModel
